var ReactBodymovinImpl = require('./ReactBodymovinImpl');
var bodymovin = require('bodymovin/build/player/bodymovin_light.min');

module.exports = ReactBodymovinImpl(bodymovin);
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;